import T, { useTranslation } from '@wojtekmaj/react-t';
import { Confetti } from 'typegpu-confetti/react';

import LinkButton from '@rewardopl/react-ui/link_button';

import {
  ButtonWrapper,
  ContentWrapper,
  Description,
  Footer,
  Icon,
  ScrollContainer,
  Title,
  Wrapper,
} from './transaction.styles';

import Heading from '../../../../../heading';

import onboarding2 from '../../../../../../static/onboarding/onboarding-2.svg';

export default function Transaction() {
  const buttonLabel = useTranslation('Go to my card');
  const sectionName = useTranslation('My rewards and coupons');

  return (
    <Wrapper>
      <Confetti size={0.5} />
      <ScrollContainer>
        <ContentWrapper>
          <Heading>Congratulations!</Heading>
          <Icon>
            <img alt="" height={320} src={onboarding2} width={320} />
          </Icon>
          <Title>
            <T>reward is yours!</T>
          </Title>
          <Description>
            <T buttonLabel={buttonLabel} sectionName={sectionName}>
              {
                'After clicking “{buttonLabel},” you will find all the details in the “{sectionName}” section.'
              }
            </T>
          </Description>
        </ContentWrapper>
      </ScrollContainer>
      <Footer>
        <ButtonWrapper>
          <LinkButton className="primary" to="/#your-code">
            <T>Go to my card</T>
          </LinkButton>
        </ButtonWrapper>
      </Footer>
    </Wrapper>
  );
}
